export default "__VITE_ASSET__Q8k3qGyP__"